import React, { useState } from 'react';
import '../stylesheets/Modal.css';

const Modal = ({ isOpen, onClose, onExcel, onPDF }) => {
  const [columnNames, setColumnNames] = useState({
    amount: 'Capital',
    start: 'Fecha de inicio',
    end: 'Fecha de cierre',
    interest: 'Interés generado'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setColumnNames(prevState => ({ ...prevState, [name]: value }));
  };

  const handleExcel = () => {
    onExcel(columnNames);
    onClose();
  };

  const handlePDF = () => {
    onPDF(columnNames);
    onClose();
  };

  return (
      isOpen && (
          <div className="modal">
            <div className="modal-content">
              <span className="close" onClick={onClose}>&times;</span>
              <h2>Exportar resultados</h2>
              <p>Ingrese el nombre que desea para las columnas de su documento.</p>
              <div className="modal-body">
                <label>
                  <span>Capital:</span>
                  <input type="text" name="amount" value={columnNames.amount} onChange={handleChange}/>
                </label>
                <label>
                  <span>Fecha de inicio:</span>
                  <input type="text" name="start" value={columnNames.start} onChange={handleChange}/>
                </label>
                <label>
                  <span>Fecha de cierre:</span>
                  <input type="text" name="end" value={columnNames.end} onChange={handleChange}/>
                </label>
                <label>
                  <span>Interés generado:</span>
                  <input type="text" name="interest" value={columnNames.interest} onChange={handleChange}/>
                </label>
              </div>
              <div className="modal-footer">
                <button className={'modal-button'} onClick={handleExcel}><i className="ph ph-file-xls"></i>
                </button>
                <button className={'modal-button'} onClick={handlePDF}><i className="ph ph-file-pdf"></i>
                </button>
              </div>
            </div>
          </div>
      )
  );
};

export default Modal;
